import { RootState } from "index";

export const selectAppState = (state: RootState) => state.app